module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bloodyMarry@3x_715c6b.jpg";